import langService from 'spa-ionata-admin/lib/services/Languages';

langService.setLanguages([
  'en',
  'zh-CN',
  'zh-TW',
  // 'ja',
  // 'ms',
]);
